module.exports = __webpack_public_path__ + "static/media/EnrolledOrganizationSuccess.89aa739e.svg";